import { Loader2Icon } from "lucide-react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

type DeleteActionDialogProps = {
  action: () => Promise<void>;
  description: string;
  isExecutingAction: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
};

const DeleteActionDialog = ({
  action,
  description,
  isExecutingAction,
  open,
  onOpenChange,
  title,
}: DeleteActionDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] w-fit overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{description}</DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button
              type="button"
              disabled={isExecutingAction}
              variant="outline"
              onClick={() => onOpenChange(!open)}
            >
              Cancel
            </Button>
          </DialogClose>
          <Button type="button" variant="destructive" disabled={isExecutingAction} onClick={action}>
            {isExecutingAction ? <Loader2Icon className="animate-spin" /> : null}
            Confirm Deletion
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteActionDialog;
